/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import C_Sample from 'components/5_Pages/Contents/C_Sample'
import T_FormOnly from 'components/4_Templates/T_FormOnly'
import { useDispatch } from 'store'
import * as PageAction from 'slicers/PageSlice'

const P_HanJoken = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(PageAction.deleteMessage())
  }, [])

  if (process.env.NODE_ENV !== 'development') {
    // dispatch(LoginAction.format())
    history.push('/') // ログイン画面に遷移
    return <></>
  }

  return (
    <T_FormOnly>
      <C_Sample />
    </T_FormOnly>
  )
}

export default P_HanJoken
